import { FC } from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const PartsCareIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 90, height = 32, ...rest }) => {
  const { token } = useToken();
  const textColor = token.colorTextBase;

  return (
    <svg width={width} height={height} viewBox="0 0 90 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M17.3681 24.6894L15.7187 27.2326L14.0028 24.7286L5.07293 11.6998H9.97744L15.6289 19.945L26.3091 3.76756C23.5245 1.41829 19.9288 0 16 0C7.16338 0 0 7.16338 0 16C0 24.8366 7.16338 32 16 32C24.837 32 32.0004 24.8366 32.0004 16C32.0004 12.6067 30.9409 9.46248 29.1394 6.87379L17.3681 24.6894Z"
        fill="#F04437"
      />
      <path
        d="M9.97895 11.6998H5.07397L14.0039 24.7282L15.7197 27.2326L17.3695 24.6895L29.1409 6.87344C28.3362 5.71783 27.3844 4.67311 26.3106 3.76721L15.6301 19.945L9.97895 11.6998Z"
        fill="white"
      />
      <path
        d="M44.946 7.70177C46.8711 7.70177 48.1321 6.67313 48.1321 5.14643V5.11308C48.1321 3.45352 46.8875 2.59044 45.0123 2.59044H42.0751V7.70177H44.946ZM40.7638 1.37915H45.1114C47.7338 1.37915 49.4597 2.77309 49.4597 5.06356V5.09654C49.4597 7.60273 47.3685 8.89689 44.8957 8.89689H42.0751V12.9961H40.7638V1.37915Z"
        fill={textColor}
      />
      <path
        d="M56.2165 9.84319V9.04645C55.5855 8.8638 54.7562 8.68115 53.7104 8.68115C52.1172 8.68115 51.2043 9.37775 51.2043 10.407V10.44C51.2043 11.5192 52.1998 12.1495 53.3619 12.1495C54.9381 12.1495 56.2165 11.2038 56.2165 9.84319ZM49.9101 10.5072V10.4735C49.9101 8.63126 51.4034 7.66904 53.5776 7.66904C54.6726 7.66904 55.4362 7.81797 56.2 8.0337V7.76809C56.2 6.24138 55.2708 5.445 53.6605 5.445C52.6484 5.445 51.8517 5.69408 51.055 6.05873L50.673 5.01365C51.6191 4.58192 52.5318 4.28369 53.7932 4.28369C55.0053 4.28369 55.9509 4.61564 56.5646 5.22937C57.1621 5.82684 57.4607 6.65703 57.4607 7.75201V12.9961H56.2V11.7184C55.6017 12.4814 54.623 13.1787 53.1128 13.1787C51.5032 13.1787 49.9101 12.2657 49.9101 10.5072Z"
        fill={textColor}
      />
      <path
        d="M59.2549 4.41644H60.5332V6.65702C61.1634 5.22936 62.4084 4.19998 64.0345 4.26714V5.64381H63.9351C62.0599 5.64381 60.5332 6.98823 60.5332 9.57766V12.9961H59.2549V4.41644Z"
        fill={textColor}
      />
      <path
        d="M65.5128 10.7225V5.54478H64.3177V4.41645H65.5128V1.82739H66.7912V4.41645H69.5119V5.54478H66.7912V10.5563C66.7912 11.6022 67.3715 11.984 68.2343 11.984C68.666 11.984 69.031 11.9004 69.4793 11.6847V12.7804C69.031 13.0125 68.5498 13.145 67.936 13.145C66.5583 13.145 65.5128 12.4649 65.5128 10.7225Z"
        fill={textColor}
      />
      <path
        d="M70.1443 11.9004L70.7917 10.9881C71.7212 11.6847 72.7499 12.0831 73.7619 12.0831C74.7912 12.0831 75.5377 11.552 75.5377 10.7226V10.6892C75.5377 9.82607 74.5257 9.4944 73.3969 9.17935C72.0526 8.79743 70.5592 8.33272 70.5592 6.75613V6.72269C70.5592 5.24587 71.7869 4.26721 73.4798 4.26721C74.5257 4.26721 75.687 4.63187 76.5663 5.21289L75.9859 6.17502C75.1892 5.66042 74.2766 5.34565 73.4471 5.34565C72.434 5.34565 71.7869 5.87679 71.7869 6.58993V6.62328C71.7869 7.4362 72.8489 7.75206 73.9944 8.10018C75.3224 8.49855 76.749 9.01315 76.749 10.5564V10.5897C76.749 12.2159 75.4049 13.1623 73.6955 13.1623C72.4677 13.1623 71.1065 12.6807 70.1443 11.9004Z"
        fill={textColor}
      />
      <path
        d="M40 24.6463V24.613C40 21.3108 42.4897 18.6055 46.0581 18.6055C48.2477 18.6055 49.559 19.3359 50.6376 20.3978L49.0115 22.273C48.1149 21.4601 47.203 20.9627 46.0408 20.9627C44.0828 20.9627 42.6717 22.5885 42.6717 24.58V24.613C42.6717 26.6045 44.0494 28.2647 46.0408 28.2647C47.3684 28.2647 48.182 27.7335 49.0943 26.9034L50.7212 28.5464C49.5261 29.8244 48.1985 30.6208 45.958 30.6208C42.5388 30.6208 40 27.9819 40 24.6463Z"
        fill={textColor}
      />
      <path
        d="M58.9372 25.5594L57.394 21.7921L55.8511 25.5594H58.9372ZM56.2491 18.7218H58.6063L63.5841 30.4216H60.9126L59.8502 27.8164H54.9381L53.8758 30.4216H51.2706L56.2491 18.7218Z"
        fill={textColor}
      />
      <path
        d="M70.0266 24.4472C71.2709 24.4472 71.9846 23.7836 71.9846 22.8042V22.7712C71.9846 21.6758 71.2213 21.1117 69.9767 21.1117H67.4371V24.4472H70.0266ZM64.8815 18.8047H70.1924C71.6692 18.8047 72.8148 19.2196 73.5778 19.9833C74.2252 20.6301 74.5733 21.5431 74.5733 22.6384V22.6714C74.5733 24.5473 73.5613 25.7249 72.0838 26.2732L74.9218 30.4217H71.9347L69.4456 26.7043H67.4371V30.4217H64.8815V18.8047Z"
        fill={textColor}
      />
      <path
        d="M76.385 18.8047H85.1473V21.0783H78.9238V23.4351H84.4008V25.7087H78.9238V28.1485H85.2302V30.4217H76.385V18.8047Z"
        fill={textColor}
      />
      <path d="M86.627 19.4317H86.1533V19.1155H87.4439V19.4317H86.9698V20.6734H86.627V19.4317Z" fill={textColor} />
      <path
        d="M87.5889 19.1155H87.9586L88.3677 19.7744L88.7772 19.1155H89.1468V20.6734H88.8062V19.6564L88.3677 20.3221H88.3587L87.9251 19.6632V20.6734H87.5889V19.1155Z"
        fill={textColor}
      />
    </svg>
  );
};

export default PartsCareIcon;
